module.exports = __webpack_public_path__ + "img/fant-farm-06.fb98f5ab.jpg";